import lrUpload from './_src/lrUpload.vue'

lrUpload.install = function(Vue) {
  Vue.component(lrUpload.name, lrUpload)
}

export default lrUpload